import { ActionReducerMap } from '@ngrx/store'
import { HeliosPanelStates } from '../root.model'
import externalTransactionReducer from './external-transaction/external-transaction.reducer'
import transactionsReducer from './transactions/transactions.reducer'

export const panelReducers: ActionReducerMap<HeliosPanelStates> = {
  transactions: transactionsReducer,
  externalTransactions: externalTransactionReducer,
}

export * from './external-transaction'
export * from './grid-state'
export * from './transactions'
